import { makeStyles } from "@fluentui/react-components";
import { primer } from "./primerDarkTheme";

export const useHeaderStyles = makeStyles({
    header: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        height: "48px",
        padding: "0 16px",
        backgroundColor: primer.header,
        borderBottom: `1px solid ${primer.border}`,
        flexShrink: 0,
    },
    icon: { width: "24px", height: "24px" },
    breadcrumb: { display: "flex", alignItems: "center", gap: "6px", flex: "1" },
    breadcrumbText: { fontSize: "14px", fontWeight: 600, color: primer.fg },
    breadcrumbSep: { fontSize: "14px", color: primer.fgSubtle },
    breadcrumbProject: { fontSize: "14px", color: primer.fgMuted },
    appName: { fontSize: "14px", fontWeight: 400, color: "#fff" },
    previewTag: {
        display: "inline-flex",
        alignItems: "center",
        padding: "0 6px",
        backgroundColor: primer.overlay,
        color: "#adadad",
        fontSize: "12px",
        fontWeight: 600,
        lineHeight: "16px",
        borderRadius: "9999px",
        maxHeight: "24px",
    },
    docsBtn: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "6px",
        borderRadius: "4px",
        color: primer.fg,
        textDecoration: "none",
        ":hover": { color: "#fff", backgroundColor: primer.overlay },
    },
    backBtn: {
        border: "none",
        background: "none",
        cursor: "pointer",
        color: "#fff",
        fontSize: "14px",
        fontWeight: 600,
        padding: "0",
        borderRadius: "4px",
        ":hover": { color: primer.blue },
    },
    rightGroup: { display: "flex", alignItems: "center", gap: "8px" },
    openAppBtn: {
        display: "flex",
        alignItems: "center",
        border: "none",
        backgroundColor: primer.green,
        color: "#fff",
        cursor: "pointer",
        padding: "3px 10px",
        borderRadius: "6px",
        fontSize: "12px",
        fontWeight: 400,
        textDecoration: "none",
        ":hover": { backgroundColor: "#2ea043" },
    },
    notifWrapper: { position: "relative" },
    bellBtn: {
        position: "relative",
        border: "none",
        background: "none",
        color: primer.fgMuted,
        cursor: "pointer",
        padding: "4px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "6px",
        ":hover": { color: primer.fg, backgroundColor: primer.overlay },
    },
    notifBadge: {
        position: "absolute",
        top: "-2px",
        right: "-2px",
        backgroundColor: primer.red,
        color: "#fff",
        borderRadius: "10px",
        fontSize: "9px",
        fontWeight: 700,
        minWidth: "14px",
        height: "14px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "0 3px",
        lineHeight: "1",
    },
    notifPanel: {
        position: "absolute",
        top: "calc(100% + 8px)",
        right: "0",
        width: "320px",
        backgroundColor: primer.surface,
        border: `1px solid ${primer.border}`,
        borderRadius: "8px",
        boxShadow: "0 8px 24px rgba(0,0,0,0.4)",
        zIndex: 100,
        overflow: "hidden",
    },
    notifHeader: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px 14px",
        borderBottom: `1px solid ${primer.border}`,
    },
    notifTitle: { fontSize: "13px", fontWeight: 600, color: primer.fg },
    markReadBtn: {
        border: "none",
        background: "none",
        color: primer.blue,
        fontSize: "11px",
        cursor: "pointer",
        padding: "0",
    },
    notifItem: {
        display: "flex",
        flexDirection: "column",
        gap: "2px",
        padding: "10px 14px",
        borderBottom: `1px solid ${primer.borderMuted}`,
        ":last-child": { borderBottom: "none" },
    },
    notifItemUnread: {
        backgroundColor: "rgba(56,139,253,0.05)",
        borderLeft: `2px solid ${primer.blue}`,
        paddingLeft: "12px",
    },
    notifMsg: { fontSize: "12px", color: primer.fg },
    notifTime: { fontSize: "11px", color: primer.fgSubtle },
    notifEmpty: { padding: "16px 14px", fontSize: "12px", color: primer.fgMuted, textAlign: "center" as const },
    userMenuWrapper: { position: "relative" },
    avatarBtn: {
        width: "28px",
        height: "28px",
        borderRadius: "50%",
        backgroundColor: primer.overlay,
        border: `1px solid ${primer.border}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "11px",
        fontWeight: 600,
        color: primer.fgMuted,
        cursor: "pointer",
        ":hover": { outline: `1px solid ${primer.blue}`, color: primer.fg },
    },
    userMenu: {
        position: "absolute",
        top: "calc(100% + 8px)",
        right: "0",
        width: "320px",
        backgroundColor: primer.surface,
        border: `1px solid ${primer.border}`,
        borderRadius: "2px",
        boxShadow: "0 16px 32px rgba(0,0,0,0.14)",
        zIndex: 100,
        overflow: "visible",
        paddingTop: "16px",
    },
    userMenuTopRow: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 24px",
    },
    userMenuOrg: { fontSize: "14px", color: "#d6d6d6" },
    userMenuSignOutBtn: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        border: "none",
        background: "none",
        color: "#d6d6d6",
        fontSize: "14px",
        cursor: "pointer",
        padding: "0",
        ":hover": { color: primer.fg },
    },
    userMenuProfile: {
        display: "flex",
        alignItems: "center",
        gap: "14px",
        padding: "16px 24px",
    },
    userMenuAvatarLarge: {
        width: "80px",
        height: "80px",
        borderRadius: "50%",
        backgroundColor: primer.overlay,
        border: `2px solid ${primer.border}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "28px",
        fontWeight: 600,
        color: primer.fgMuted,
        flexShrink: 0,
    },
    userMenuProfileInfo: {
        display: "flex",
        flexDirection: "column",
    },
    userMenuName: { fontSize: "20px", fontWeight: 600, color: "#faf9f8" },
    userMenuEmail: { fontSize: "12px", color: "#d6d6d6" },
    userMenuDivider: { height: "1px", backgroundColor: primer.border, margin: "0" },
    userMenuItem: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        width: "100%",
        height: "52px",
        padding: "4px 16px",
        border: "none",
        background: "none",
        color: "#d6d6d6",
        fontSize: "14px",
        cursor: "pointer",
        textAlign: "left" as const,
        boxSizing: "border-box" as const,
        ":hover": { backgroundColor: primer.overlay },
    },
    userMenuItemActive: {
        backgroundColor: "#3d3d3d",
        color: "#ffffff",
    },
    dirFlyout: {
        position: "absolute",
        right: "calc(100% + 8px)",
        top: "0",
        width: "320px",
        backgroundColor: "#292929",
        border: "1px solid #464646",
        borderRadius: "2px",
        boxShadow: "0 16px 32px rgba(0,0,0,0.14)",
        display: "flex",
        flexDirection: "column",
        padding: "8px",
        gap: "8px",
        maxHeight: "300px",
        overflowY: "auto",
        zIndex: 101,
    },
    dirFlyoutItem: {
        display: "flex",
        gap: "8px",
        alignItems: "flex-start",
        padding: "0",
        border: "none",
        background: "none",
        color: "#faf9f8",
        fontSize: "14px",
        cursor: "pointer",
        textAlign: "left" as const,
        ":hover": { opacity: 0.8 },
    },
    dirFlyoutCheckmark: {
        width: "16px",
        height: "24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        color: "#faf9f8",
    },
    dirFlyoutItemInfo: {
        display: "flex",
        flexDirection: "column",
    },
    dirFlyoutItemName: {
        fontSize: "14px",
        lineHeight: "20px",
        color: "#faf9f8",
    },
    dirFlyoutItemDomain: {
        fontSize: "12px",
        lineHeight: "16px",
        color: "#adadad",
    },
    avatar: {
        width: "28px",
        height: "28px",
        borderRadius: "50%",
        backgroundColor: primer.overlay,
        border: `1px solid ${primer.border}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "12px",
        color: primer.fgMuted,
    },
});
